import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderMainPage from '../../header/HeaderMainPage';
import { FaReply, FaSearch, FaFilePdf } from "react-icons/fa";
import { FiRefreshCw } from "react-icons/fi"
import Swal from "sweetalert2";
import { FaArrowLeft, FaInfoCircle } from 'react-icons/fa';
import ReactQuill from 'react-quill';
// import "react-quill/dist/quill.snow.css";
import 'quill/dist/quill.snow.css';

// Define the modules for ReactQuill editor
const modules = {
    toolbar: [
        [{ header: [1, 2, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ direction: "rtl" }],
        [{ color: [] }, { background: [] }],
        ["blockquote", "code-block"],
        ["link", "image"],
        ["clean"],
    ],
};

// Define column widths
const columnWidths = {
    star: '50px',
    email: '150px',
    date: '100px',
};
const InboxConversationSkeleton = () => {
    return (
        <div className="flex flex-col lg:flex-row gap-2 flex-1 animate-pulse">

            {/* LEFT PANEL SKELETON */}
            <div className="w-full lg:w-[300px] bg-white border-r border-gray-200 flex flex-col p-2">

                {/* Search skeleton */}
                <div className="flex gap-2 mb-3">
                    <div className="h-8 flex-1 rounded-full bg-gray-200" />
                    <div className="h-8 w-20 rounded-full bg-gray-200" />
                </div>

                {/* List skeleton */}
                <div className="flex-1 space-y-3">
                    {[...Array(6)].map((_, i) => (
                        <div key={i} className="flex items-center gap-3">
                            <div className="h-9 w-9 rounded-full bg-gray-300" />
                            <div className="flex-1 space-y-2">
                                <div className="h-3 w-3/4 bg-gray-300 rounded" />
                                <div className="h-2 w-1/2 bg-gray-200 rounded" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* RIGHT PANEL SKELETON */}
            <div className="flex-1 bg-gray-50 rounded-md p-4 flex flex-col space-y-4">

                {/* Header */}
                <div className="bg-white p-3 rounded-md border flex justify-between">
                    <div className="space-y-2">
                        <div className="h-3 w-40 bg-gray-300 rounded" />
                        <div className="h-2 w-56 bg-gray-200 rounded" />
                    </div>
                    <div className="h-8 w-8 bg-gray-200 rounded-full" />
                </div>

                {/* Conversation bubbles */}
                {[...Array(3)].map((_, i) => (
                    <div key={i} className="bg-white border rounded-md p-4 space-y-3">
                        <div className="flex justify-between">
                            <div className="h-3 w-32 bg-gray-300 rounded" />
                            <div className="h-2 w-24 bg-gray-200 rounded" />
                        </div>

                        <div className="space-y-2">
                            <div className="h-3 bg-gray-200 rounded w-full" />
                            <div className="h-3 bg-gray-200 rounded w-5/6" />
                            <div className="h-3 bg-gray-200 rounded w-4/6" />
                        </div>

                        {/* AI buttons */}
                        <div className="flex gap-2">
                            <div className="h-6 w-24 bg-gray-200 rounded-full" />
                            <div className="h-6 w-24 bg-gray-200 rounded-full" />
                            <div className="h-6 w-28 bg-gray-200 rounded-full" />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};


const ReplyBox = ({ replyHistory, handleCloseRepSuggest, activeTab, AutoReply }) => {
    // Extract the last reply from the history, showing analysis on the last reply
    // to help user understand the email, including th

    const lastReply = replyHistory.at(-1); // Get last item
    const subject = lastReply?.suggested_response?.subject || "";
    const body = lastReply?.suggested_response?.body || "";
    const explanation = lastReply?.explanation || "No Explanation";

    // State for showing explanation box
    const [showExplanation, setShowExplanation] = useState(false);

    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);


    const AutoPasteReply = () => {
        AutoReply(activeTab, subject, body)
    }

    return (
        <div className="fixed inset-0 flex items-center justify-center p-3 sm:p-6 z-50 bg-black/40 animate-fadeIn">
            <div className="relative flex flex-col lg:flex-row items-start gap-">
                {/* Main Reply Box */}
                <div className="bg-white p-5 rounded-xl shadow-md w-full sm:w-[90vw] md:w-[620px] max-h-[90vh] flex flex-col">
                    {/* Subject Input */}
                    {activeTab === "mail" && (
                        <div className="mb-2">
                            <label className="block text-sm font-semibold text-gray-700 mb-1">Subject:</label>
                            <input
                                type="text"
                                value={subject}
                                readOnly
                                className="w-full rounded-lg p-2.5 bg-gray-100 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                            />
                        </div>
                    )}

                    {/* Message Input */}
                    <div className="mb-2">
                        <label className="block text-md font-medium text-gray-700 mb-1">
                            {activeTab === "mail" ? "Content" : activeTab === "linkedin" ? "Message" : "Content"}
                        </label>
                        <ReactQuill
                            theme="snow"
                            value={body}
                            modules={{ toolbar: false }}
                            readOnly={true}
                            className="min-h-[180px] sm:min-h-[250px] lg:min-h-[350px] rounded-lg mb-3 bg-gray-50"
                        />
                    </div>

                    {/* Buttons: Close & Star */}
                    <div className="flex flex-col sm:flex-row justify-end gap-3 mt-4">
                        <button
                            className="bg-gray-200 text-gray-700 px-4 py-2 rounded-full hover:bg-gray-300 transition"
                            onClick={handleCloseRepSuggest}
                        >
                            Close
                        </button>

                        <button
                            className="px-4 py-2 rounded-full border border-gray-200 text-gray-700 bg-white hover:bg-indigo-600 hover:text-white transition"
                            onClick={AutoPasteReply}
                        >
                            Reply ✨
                        </button>

                        {/* Star/Explain Button */}
                        <button
                            className="px-4 py-2 rounded-full border border-gray-200 text-gray-700 bg-white hover:bg-indigo-600 hover:text-white transition"
                            // onClick={() => setShowExplanation(!showExplanation)}
                            onClick={() => setShowExplanation(prev => !prev)}

                            onMouseEnter={() => setShowExplanation(true)}
                            onMouseLeave={() => setShowExplanation(false)}
                        >
                            Explain ✨
                        </button>
                    </div>
                </div>

                {/* Explanation Box - Positioned to the right */}
                {showExplanation && (
                    <div className="w-full lg:w-[380px] p-4 rounded-xl shadow-sm bg-white">
                        <label className="block text-md font-medium text-gray-700 mb-1">Explanation ✨</label>
                        <textarea
                            value={explanation}
                            readOnly
                            className="w-full h-[200px] sm:h-[300px] lg:h-[400px] resize-none bg-gray-50 rounded-lg p-2 focus:outline-none"
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

const MailboxContent = ({ activeTab }) => {

    const roboman_api = process.env.REACT_APP_ROBOMAN_API;
    const campaignId = localStorage.getItem("campaign_id");
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [replyBox, setReplyBox] = useState(false);
    const [replyMailSubject, setReplyMailSubject] = useState("");
    const [replyMailContent, setReplyMailContent] = useState("");
    const [sentMails, setSentMails] = useState([]);
    const [replyBoxSuggest, setReplyBoxSuggest] = useState(false);

    const [replyLinkedInContent, setReplyLinkedInContent] = useState("");

    const [selected_internal_id, setSelectedInternalID] = useState(null);
    const [replyHistory, setReplyHistory] = useState([]);
    const [selectedMail, setSelectedMail] = useState([]);
    const [linkedInMessages, setLinkedInMessage] = useState([]);
    const [linkedinMessHistory, setLinkedInMessHistory] = useState([]);
    const [selectedLinkedin, setSelectedLinkedin] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const authToken = localStorage.getItem("access_token");

    const [showMailPanel, setMailDataPanel] = useState(false);
    const [selectMailName, setSelectMailName] = useState(null);
    const [mailData, setMailData] = useState(null);

    const [showLinkedinPanel, setLinkedinDataPanel] = useState(false);
    const [selectLinkedInName, setSelectLinkedinName] = useState(null);
    const [LinkedinData, setLinkedinData] = useState(null);
    const [isConversationLoading, setIsConversationLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);


    const avatarColors = [
        "bg-slate-400",
        "bg-gray-400",
        "bg-zinc-400",
        "bg-stone-400",

        "bg-blue-400",
        "bg-sky-400",
        "bg-cyan-400",

        "bg-teal-400",
        "bg-emerald-400",

        "bg-indigo-400",
        "bg-violet-400",

        "bg-rose-400",
    ];

    const getAvatarColor = (name = "") => {
        let hash = 0;
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        return avatarColors[Math.abs(hash) % avatarColors.length];
    };



    const fetchSentMails = async () => {
        /* 
        * Fetch sent emails from the API 
        */
        setIsLoading(true);
        try {
            const response = await fetch(`${roboman_api}/campaign/${campaignId}/emails/sent-mails`, {
                method: "GET",
                headers: {
                    "accept": "application/json",
                    "Authorization": authToken,
                },
            });

            if (!response.ok) {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Failed to fetch sent emails.",
                    confirmButtonText: "OK"
                });
                return; // Exit the function early
            }

            const data = await response.json();
            console.log(data);
            console.log("Fetched sent mails:");
            setSentMails(data);
        } catch (error) {
            Swal.fire({
                title: "Error!",
                text: error.message,
                icon: "error",
                confirmButtonText: "Okay"
            });
        }
        finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        // AutoSelect first mail
        if (
            activeTab === "mail" &&
            sentMails.length > 0 &&
            selectedMail.length === 0
        ) {
            const firstMail = sentMails[0];

            handleMailReplyHis(
                firstMail.company_id,
                firstMail.rep_name,
                firstMail.rep_email
            );
            return;
        }

        // AutoSelect first mail
        if (
            activeTab === "linkedin" &&
            linkedInMessages.length > 0 &&
            selectedLinkedin.length === 0
        ) {
            const firstLinkedin = linkedInMessages[0];

            handleShowingLinkedinReply(
                firstLinkedin.company_id,
                firstLinkedin.rep_name
            );
        }
    }, [
        activeTab,
        sentMails,
        linkedInMessages
    ]);



    const fetchSentLinkedin = async () => {
        /*
        * Fetch sent LinkedIn messages from the API
        */

        setIsLoading(true);
        try {
            const response = await fetch(`${roboman_api}/campaign/${campaignId}/linkedin/message/sent-messages`, {
                method: "GET",
                headers: {
                    "accept": "application/json",
                    "Authorization": authToken,
                },
            });

            if (!response.ok) {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Failed to fetch sent LinkedIn messages.",
                    confirmButtonText: "OK"
                });
                return;
            }

            const data = await response.json();
            console.log("Fetched sent LinkedIn messages:");
            setLinkedInMessage(data);
        } catch (error) {
            Swal.fire({
                title: "Error!",
                text: error.message,
                icon: "error",
                confirmButtonText: "Okay"
            });
        }
        finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        // Fetch sent emails and LinkedIn messages when the component mounts
        console.log("Switch to tab:", activeTab)
        if (activeTab === "mail") {
            fetchSentMails();
            setReplyBox(false)
            setReplyLinkedInContent("")
            setReplyMailSubject("")
            setReplyMailContent("")

        } else if (activeTab === "linkedin") {
            fetchSentLinkedin();
            setReplyBox(false)
            setReplyLinkedInContent("")
            setReplyMailSubject("")
            setReplyMailContent("")
        }
    }, [activeTab])

    const handleShowMailData = (mail_data, mail_name) => {
        // Show the mail data panel
        if (showMailPanel === false) setMailDataPanel(true);
        setMailData(mail_data)
        setSelectMailName(mail_name)
    }

    const handleMailReplyHistory = async (company_id, internal_id) => {
        /*
        * Fetch reply history for a specific email
        */

        try {
            // Swal.fire({
            //     title: 'Fetching Email Reply...',
            //     text: 'Please wait while the Email history is being loaded.',
            //     allowOutsideClick: false,
            //     didOpen: () => {
            //         Swal.showLoading(); // Show loading spinner
            //     },
            // });

            setIsConversationLoading(true);
            const response = await fetch(`${roboman_api}/campaign/companies/${company_id}/emails/conversation`,
                {
                    method: "GET",
                    headers: {
                        "Accept": "application/json",
                        "Authorization": authToken, // Replace with your actual token
                    },
                }
            );

            if (!response.ok) {
                console.error(`Error: ${response.status}`);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: `Failed to load email reply history. Please try again`,
                });
                return;
            }

            const data = await response.json();
            const matching_mail_history = data.filter(item => item.sent_email_internal_id === internal_id || item.internal_id === internal_id);
            console.log("email history fetched")
            if (matching_mail_history) {
                setReplyHistory(matching_mail_history); // Set the matching item to state
                console.log(matching_mail_history)
            } else {
                setReplyHistory([]); // Set to null if no match is found 
            }

            // Swal.close();

        } catch (error) {
            console.error("Failed to fetch mail reply history:", error);
            // Show error alert
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Failed to load email reply history. Please try again later.",
            });

        }
        finally {
            setIsConversationLoading(false);
        }
    };

    const handleMailReplyHis = async (company_id, mail_rep_name, mail_rep_info) => {
        /*
        * Fetch reply history for a specific email
        */
        setReplyMailSubject("");
        setReplyMailContent("");
        setReplyBox(false);

        try {
            // Swal.fire({
            //     title: 'Fetching Email Reply...',
            //     text: 'Please wait while the Email history is being loaded.',
            //     allowOutsideClick: false,
            //     didOpen: () => {
            //         Swal.showLoading(); // Show loading spinner
            //     },
            // });

            setIsConversationLoading(true)
            const response = await fetch(`${roboman_api}/campaign/companies/${company_id}/emails/conversation`,
                {
                    method: "GET",
                    headers: {
                        "Accept": "application/json",
                        "Authorization": authToken, // Replace with your actual token
                    },
                }
            );

            if (!response.ok) {
                console.error(`Error: ${response.status}`);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: `Failed to load email reply history. Please try again`,
                });
                return;
            }

            const data = await response.json();
            console.log("email history fetched")
            if (data) {
                setReplyHistory(data); // Set the matching item to state
            } else {
                setReplyHistory([]); // Set to null if no match is found
            }
            Swal.close();

        } catch (error) {
            console.error("Failed to fetch mail reply history:", error);
            // Show error alert
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Failed to load email reply history. Please try again later.",
            });
        }
        finally {
            setIsConversationLoading(false)
        }

        setSelectedMail([mail_rep_name, mail_rep_info, company_id]);


    };

    const handleShowingEmailReply = (company_id, internal_id, mail_subject, mail_to_info, fisrt_mail_body) => {
        // Show the mail data panel
        setSelectedInternalID(internal_id);
        setReplyBox(false); // Hide reply box when switching emails
        handleMailReplyHistory(company_id, internal_id); // Fetch reply history for the selected email
        setSelectedMail([mail_subject, mail_to_info, fisrt_mail_body, company_id]);
    };

    const handleLinkedInReplyHistory = async (company_id) => {
        /*
        * Fetch reply history for a specific LinkedIn message
        */
        try {
            // Swal.fire({
            //     title: 'Fetching LinkedIn Messages...',
            //     text: 'Please wait while the LinkedIn message history is being loaded.',
            //     allowOutsideClick: false,
            //     didOpen: () => {
            //         Swal.showLoading(); // Show loading spinner
            //     },
            // });

            setIsConversationLoading(true);

            const response = await fetch(`${roboman_api}/campaign/companies/${company_id}/linkedin/messages/chat`,
                {
                    method: "GET",
                    headers: {
                        "Accept": "application/json",
                        "Authorization": authToken,
                    },
                }
            );

            if (!response.ok) {
                console.error(`Error: ${response.status}`);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: `Failed to load linkedin message history. Please try again`,
                });
                return;
            }

            const data = await response.json();

            console.log("linkedin message history fetched")
            if (data) {
                setLinkedInMessHistory(data); // Set the matching item to state
            } else {
                setLinkedInMessHistory([]); // Set to null if no match is found
            }
            // Swal.close();
        } catch (error) {
            console.error("Failed to fetch mail reply history:", error);
            // Show error alert
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Failed to load linkedin message history. Please try again later.",
            });
        } finally {
            setIsConversationLoading(false);
        }
    };

    const handleShowingLinkedinReply = (company_id, rep_name) => {
        // Show the mail data panel
        setReplyBox(false); // Hide reply box when switching emails
        handleLinkedInReplyHistory(company_id); // Fetch reply history for the selected email
        setSelectedLinkedin([rep_name, company_id]);
    };

    const handleMailReply = async () => {
        /*
        * Send a reply to the selected email
        */
        if (!replyMailSubject.trim() || !replyMailContent.trim()) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Information',
                text: 'Please enter both subject and content before replying.',
            });
            return;
        }

        try {
            Swal.fire({
                title: 'Sending Reply...',
                text: 'Please wait while your reply is being sent.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });

            const response = await fetch(`${roboman_api}/campaign/emails/reply-mails/respond`, {
                method: 'POST',
                headers: {
                    'accept': 'application/json',
                    'Authorization': authToken,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    company_id: selectedMail[2],
                    subject: replyMailSubject,
                    body: replyMailContent,
                }),
            });

            if (response.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Reply Sent',
                    text: 'Your reply has been successfully sent.',
                });

                // Clear form
                setReplyMailSubject("");
                setReplyMailContent("");
                setReplyBox(false);
            } else {
                const err = await response.json();
                Swal.fire({
                    icon: 'error',
                    title: 'Failed to Send',
                    text: err?.message || 'Something went wrong while sending the reply.',
                });
            }

        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'Something went wrong.',
            });
        }
    };

    const handleLinkedReply = async () => {
        /*
        * Send a reply to the selected LinkedIn message
        */
        if (!replyLinkedInContent.trim()) {
            Swal.fire({
                icon: 'warning',
                title: 'Missing Information',
                text: 'Please enter your message before replying.',
            });
            return;
        }

        try {
            Swal.fire({
                title: 'Sending Reply...',
                text: 'Please wait while your reply is being sent.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });

            const response = await fetch(`${roboman_api}/campaign/linkedin/message/respond`, {
                method: 'POST',
                headers: {
                    'accept': 'application/json',
                    'Authorization': authToken,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    company_id: selectedLinkedin[1],
                    message_content: replyLinkedInContent,
                }),
            });

            // Clear form
            setReplyLinkedInContent("");
            setReplyBox(false);

            if (response.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Reply Sent',
                    text: 'Your reply message has been successfully sent.',
                });
            } else {
                const err = await response.json();
                Swal.fire({
                    icon: 'error',
                    title: 'Failed to Send',
                    text: err?.message || 'Something went wrong while sending the reply.',
                });
            }

        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'Something went wrong.',
            });
        }
    };

    const handleDiscard = () => {
        // Function to discard reply
        setReplyBox(false);
        setReplyMailSubject("");
        setReplyMailContent("");
        setReplyLinkedInContent("");
    };

    const handleCloseRepSuggest = () => {
        setReplyBoxSuggest(false);
    };

    const parseHTML = (htmlString) => {
        // Safely parse HTML string and extract body content
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");
        return doc.body.innerHTML; // Extracts only the body content safely
    };

    const filteredSentMails = sentMails.filter(email => {
        if (activeTab !== 'mail') return true; // Only filter when "Mail" tab is active

        const searchLower = searchTerm.toLowerCase();

        // Check if the search term matches the `rep_name`
        const nameMatch = email.rep_name?.toLowerCase().includes(searchLower);

        // Check if the search term matches the `rep_email`
        const emailMatch = email.rep_email?.toLowerCase().includes(searchLower);

        return nameMatch || emailMatch;
    });

    const filteredSentLinkedinMesssage = linkedInMessages.filter(linkedinmess => {
        if (activeTab !== 'linkedin') return true; // Only filter when "Mail" tab is active

        const searchLower = searchTerm.toLowerCase();

        // Check if the search term matches the `rep_name`
        const nameMatch = linkedinmess.rep_name?.toLowerCase().includes(searchLower);

        return nameMatch;
    });

    const ToggleButton = ({ label, content, type }) => {
        // State to manage the open/close state of the button
        const [isOpen, setIsOpen] = useState(false);

        let buttonStyles = "bg-white border-2 text-[#223F9E] px-4 py-2 min-h-[40px] rounded-full shadow-md transition-all text-left border-2 border-[#223F9E] hover:bg-gray-200";
        let contentBoxStyles = "mt-2 p-3 rounded shadow-lg z-30 text-left border-2 border-[#223F9E] bg-white";
        let contentStyles = "text-sm text-left";

        if (type === "sentiment") {
            if (isOpen) {
                if (content === "positive") {
                    buttonStyles = "bg-green-500 text-white border-2 px-4 py-2 min-h-[40px] rounded-full shadow-md transition-all text-left";
                } else if (content === "negative") {
                    buttonStyles = "bg-red-500 text-white border-2 px-4 py-2 min-h-[40px] rounded-full shadow-md transition-all text-left";
                } else {
                    buttonStyles = "bg-gray-300 text-black border-2 px-4 py-2 min-h-[40px] rounded-full shadow-md transition-all text-left";
                }
            }
        } else if (type === "emotion") {
            contentBoxStyles += " border border-blue-500 text-black w-full";
            contentStyles += " whitespace-pre-wrap";
        } else if (type === "key_takeaway") {
            contentBoxStyles += " text-black border border-gray-400 w-full";
        }

        return (
            <div className="relative inline-block w-auto">
                <button
                    onClick={() => setIsOpen(!isOpen)}
                    className={buttonStyles}
                >
                    {isOpen && type === "sentiment" ? (content === "positive" ? "Positive" : "Negative") : label}
                </button>

                {isOpen && type !== "sentiment" && (
                    <div className={contentBoxStyles}>
                        <p className={contentStyles}>{content}</p>
                    </div>
                )}
            </div>
        );
    };

    const AutoReply = (activeTab, subject, content) => {
        if (activeTab === "mail") {
            setReplyMailSubject(subject)
            setReplyMailContent(content)
        } else {
            setReplyLinkedInContent(content)
        }

        setReplyBoxSuggest(false);
        setReplyBox(true);
    }

    return (
        <>
            {isLoading ?
                (<InboxConversationSkeleton />) :

                (<div className="flex flex-col lg:flex-row flex-1 min-h-0 gap-0">

                    {/* Left Panel: Email List */}
                    <div className="w-full lg:w-[320px] lg:shrink-0 bg-white border-r border-gray-200 flex flex-col min-h-0">


                        {/* Top Box with Search and Dropdown */}

                        {/* <div className="bg-white mb-2 rounded-md "> */}
                        <div className="px-4 py-3 border-b border-gray-100">
                            {/* Search Bar */}
                            <input
                                type="text"
                                placeholder="Search Email or Name..."
                                className="w-full px-4 py-2 text-sm rounded-full bg-gray-100 focus:bg-white focus:outline-none"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />

                            {/* Dropdown for Sorting Options */}
                            {/* <select className="px-3 py-1.5 text-sm rounded-full bg-gray-100">
                            <option value="date">Date</option>
                            <option value="name">Name</option>
                        </select> */}
                        </div>
                        {/* </div> */}

                        {/* Email & LinkedIn List */}
                        <div className="flex-1 overflow-y-auto px-2">
                            {/* Email Panel */}
                            {activeTab === "mail" ? (
                                <div>
                                    <div>
                                        {/* Title */}
                                        <h2 className="text-xs font-semibold text-gray-500 uppercase px-3 py-2">Inbox</h2>

                                        {/* Email List */}
                                        <div className="rounded-md p-2">
                                            {!filteredSentMails || filteredSentMails.length === 0 ? (
                                                <p className="text-center text-gray-500 ">No Email Sent</p>
                                            ) : (
                                                <div className="grid grid-cols-1 gap-4">
                                                    {filteredSentMails.map((mail, index) =>
                                                        mail.rep_name || mail.rep_info ? (
                                                            <div
                                                                key={index}
                                                                className={`flex items-center gap-3 px-3 py-2 rounded-lg cursor-pointer border-l-4
                                                        ${selectedMail[0] === mail.rep_name
                                                                        ? "bg-indigo-50 border-indigo-600"
                                                                        : "border-transparent hover:bg-gray-50"}`}
                                                                onClick={() => handleMailReplyHis(mail.company_id, mail.rep_name, mail.rep_email)}
                                                            // onClick={() => handleShowMailData(mail.sent_emails, mail.rep_name)}
                                                            >
                                                                <div
                                                                    className={`h-9 w-9 rounded-full flex items-center justify-center
                                                                    text-white text-sm font-semibold
                                                                    ${getAvatarColor(mail.rep_name)}`}
                                                                >
                                                                    {mail.rep_name?.charAt(0)}
                                                                </div>

                                                                <div className="flex-1 min-w-0">
                                                                    <div className="text-sm font-semibold text-gray-900 truncate">
                                                                        {mail.rep_name}
                                                                    </div>
                                                                    <div className="text-xs text-gray-500 truncate">
                                                                        {mail.rep_email}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div key={index} className="p-4 bg-white rounded-md shadow-sm border cursor-pointer">
                                                                <p className="text-center text-gray-500">Invalid Email Data</p>
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* {showMailPanel === false ? (
                        <div>
                            <h2 className="text-lg font-semibold text-gray-900 mt-2 mb-2 px-2">Inbox Email</h2>
                            <div className="overflow-y-auto h-full rounded-md p-2">
                            {!filteredSentMails || filteredSentMails.length === 0 ? (
                                <p className="text-center text-gray-500">No Email Sent</p>
                            ) : (
                                <div className="grid grid-cols-1 gap-4">
                                    {filteredSentMails.map((mail, index) =>
                                        mail.rep_name || mail.rep_info ? (
                                        <div
                                            key={index}
                                            className={`p-4 bg-white rounded-md shadow-sm border cursor-pointer hover:bg-gray-200`}
                                            // onClick={() => handleEmailClick(mail.internal_id, mail.subject, mail.to_info)}
                                            onClick={() => handleShowMailData(mail.sent_emails, mail.rep_name)}
                                        >
                                            <div className="flex justify-between items-center">
                                                <div className="text-lg font-medium text-gray-900"> {mail.rep_name} </div>
                                                <div className="text-sm text-gray-500"> {mail.rep_email} </div>
                                            </div>
                                        </div>
                                        ) : (
                                        <div key={index} className="p-4 bg-white rounded-md shadow-sm border cursor-pointer">
                                            <p className="text-center text-gray-500">Invalid Email Data</p>
                                        </div>
                                        )
                                    )}
                                </div>
                            )}
                            </div>
                        </div>
                        ) : (
                        <div className="bg-white p-4 rounded-md shadow-md w-full z-50">
                            <div className="flex items-center space-x-4 mb-5">
                                <button  className="text-gray-600 hover:text-gray-900 rounded-full bg-gray-200 p-2"
                                        onClick={() => {
                                            setMailDataPanel(false);
                                            setSelectedMail([]);
                                            setReplyHistory([]);
                                        }} 
                                >
                                    <FaArrowLeft className="h-4 w-4" />
                                </button>
                                <div>
                                    <h2 className="text-xl font-bold text-gray-900"> Email to {selectMailName || "Unknown"} </h2>
                                </div>
                            </div>

                            <div className="grid grid-cols-1 gap-4">
                                {mailData && mailData.length > 0 && mailData.map((email, index) => (
                                    <div
                                        key={index}
                                        className="p-4 bg-gray-100 rounded-md shadow-sm border cursor-pointer hover:bg-gray-200"
                                        onClick={() => handleShowingEmailReply(email.company_id, email.internal_id, email.subject, email.to_info, email.body)}
                                    >
                                        <div className="text-lg font-medium text-gray-900">
                                        {email.to_info[0]?.display_name || "Unknown"}
                                        </div>

                                        <div className="text-sm text-gray-500">
                                        {new Date(email.created_at).toLocaleString()}
                                        </div>

                                        <div className="text-sm text-gray-700 mt-2">
                                        {email.body_plain.length > 100
                                            ? `${email.body_plain.substring(0, 100)}...`
                                            : email.body_plain}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        )} */}
                                </div>
                            ) : (
                                // LinkedIn Tab - Under Development
                                <div>

                                    <div>
                                        {/* Title */}
                                        <h2 className="text-xs font-semibold text-gray-500 uppercase px-3 py-2">Inbox</h2>

                                        {/* LinkedIn List */}
                                        <div className="rounded-md p-2">
                                            {!filteredSentLinkedinMesssage || filteredSentLinkedinMesssage.length === 0 ? (
                                                <p className="text-center text-gray-500">No LinkedIn Message</p>
                                            ) : (
                                                <div className="grid grid-cols-1 gap-4">
                                                    {filteredSentLinkedinMesssage.map((lnk_mess, index) =>
                                                        lnk_mess.rep_name || lnk_mess.rep_linkedin_address ? (
                                                            <div
                                                                key={index}
                                                                className={`flex items-center gap-3 px-3 py-2 rounded-lg cursor-pointer border-l-4


                                                            ${selectedLinkedin[0] === lnk_mess.rep_name
                                                                        ? "bg-indigo-50 border-indigo-600 "
                                                                        : "border-transparent hover:bg-gray-50"}
                                                        `}
                                                                onClick={() => handleShowingLinkedinReply(lnk_mess.company_id, lnk_mess.rep_name, lnk_mess.sent_messages)}
                                                            >
                                                                <div className={`h-9 w-9 rounded-full bg-indigo-500 flex items-center justify-center text-white text-sm font-semibold
                                                                    ${getAvatarColor(lnk_mess.rep_name)}
                                                                    `}>
                                                                    {lnk_mess.rep_name?.charAt(0)}
                                                                </div>

                                                                <div className="flex justify-between items-center">
                                                                    <div className="text-sm  text-gray-900 truncate"> {lnk_mess.rep_name} </div>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div key={index} className="p-4 bg-white rounded-md shadow-sm border cursor-pointer">
                                                                <p className="text-center text-gray-500">Invalid Linkedin Data</p>
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                </div>
                            )}
                        </div>
                    </div>

                    {/* Right Panel: Mail & LinkedIn History */}
                    <div className="w-full flex flex-col flex-1 bg-gray-50 min-h-0">
                        {activeTab === "mail" ? (
                            <>
                                {/* Information Box */}
                                {/* <div className="bg-white  border shadow-sm rounded-md  mb-1"> */}
                                {selectedMail.length > 0 && (
                                    // <div className="">
                                    <div className="sticky top-0 z-30 bg-white px-2 py-2 border-t sm:border-t-0 sm:border-b mt-1  border-gray-100 flex items-center gap-2 sm:gap-4 justify-between">


                                        {/* Subject and Receiver Info*/}
                                        <div className="flex-1 mx-2 min-w-0">
                                            <h2 className="text-lg font-semibold text-gray-900">{selectedMail[0] || "Unknown Subject"}</h2>
                                            <p className="text-xs text-gray-500">
                                                {/* To: {selectedMail[1] && Array.isArray(selectedMail[1])
                                                    ? selectedMail[1].map((info) => info.identifier).join(", ")
                                                    : "Unknown Receiver"} */}
                                                {selectedMail[1] ? selectedMail[1] : "Unknown Receiver"}
                                            </p>
                                        </div>

                                        {/* Refresh Button */}
                                        <button
                                            // onClick={() => handleMailReplyHistory(selectedMail[3], selected_internal_id)} // Call the refresh function
                                            onClick={() => handleMailReplyHis(selectedMail[2], selectedMail[0], selectedMail[1])} // Call the refresh function
                                            className="inline-flex items-center gap-2  rounded-l borde border-gray-20  px-2 py-1.5 sm:px-3 sm:py-2 text-sm font-medium    duration-200 active:scale-[0.97]  transition">


                                            <FiRefreshCw className="text-[10px] sm:text-[13px] text-indigo-600 group-hover:text-white text-xl font-extrabold" />

                                        </button>
                                    </div>
                                )



                                }

                                {/*Display selectedMail[3] in a styled box with HTML treatment */}
                                {/* <div className="bg-gray-100 p-4 rounded-md shadow-sm mt-4">
                                        <div className="text-gray-700 space-y-2">
                                            {selectedMail[2] &&
                                                selectedMail[2]
                                                    .split("\n\n")
                                                    .map((paragraph, index) => (
                                                        <div key={index} dangerouslySetInnerHTML={{ __html: parseHTML(paragraph) }} />
                                                    ))}
                                        </div>
                                    </div> */}
                                {/* </div> */}

                                {/* </div> */}

                                {/* Conversation History Email */}
                                <div className="flex-1 px-4 py-3 overflow-y-auto">
                                    {isConversationLoading ? (
                                        <div className="flex flex-1 items-center justify-center">
                                            <div className="flex items-center gap-3 text-gray-600">
                                                <div className="h-5 w-5 animate-spin rounded-full border-2 border-gray-300 border-t-indigo-600"></div>
                                                <span className="text-sm">Loading conversation…</span>
                                            </div>
                                        </div>
                                    ) : replyHistory && replyHistory.length > 0 ? (
                                        <div className="flex-1 space-y-4">
                                            {replyHistory
                                                .slice()
                                                .sort((a, b) => new Date(a.receiver_time) - new Date(b.receiver_time))
                                                .map((mail, idx) => {
                                                    // ✅ ONLY RELEVANT CHANGE: detect attachment on this specific message/card
                                                    const hasPdfProposal = mail?.attachments === true

                                                    return (

                                                        <div key={idx} className=" bg-white rounded-xl overflow-hidden shadow-sm">
                                                            {/* Upper Box - Sender Info */}
                                                            <div className="flex items-center justify-between px-4 py-2 bg-white">

                                                                {/* <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2"> */}
                                                                {mail.role === "prospect" ? (
                                                                    <h3 className="text-base sm:text-lg font- text-gray-900">
                                                                        {mail.from_info?.display_name || mail.from_info?.identifier || "Unknown Sender"}
                                                                    </h3>

                                                                ) : (
                                                                    <h3 className="text-base sm:text-lg font- text-gray-900"> You </h3>
                                                                )}

                                                                {/* ✅ Badge + Timestamp (top-right) */}
                                                                <div className="flex-wrap flex items-center  justify-between gap-2  text-xs text-gray-600">
                                                                    {hasPdfProposal && (
                                                                        <a target="_blank" href={`https://autopilotproposals.s3.ap-south-1.amazonaws.com/${mail.campaign_idx}__${mail.rep_idx}__${mail.user_idx}.pdf`}>
                                                                            <span className="inline-flex items-center gap-1 px-2 py-0.5 text-[11px] font-medium rounded-full border border-red-300 bg-red-50 text-red-700">
                                                                                <FaFilePdf className="text-red-600" />
                                                                                PDF Proposal
                                                                            </span>
                                                                        </a>
                                                                    )}
                                                                    <span className="text-xs text-gray-600">
                                                                        {mail.timestamp ? new Date(mail.timestamp).toLocaleString() : "N/A"}
                                                                    </span>
                                                                </div>
                                                                {/* </div> */}
                                                            </div>

                                                            {/* Separator Line */}
                                                            {/* <div className="h-[1px] bg-gray-200 w-full"></div> */}

                                                            {/* Lower Box - Email Body */}
                                                            <div className=" px-4 py-3 prose prose-sm max-w-none text-gray-700 ">
                                                                {mail.body?.trim().startsWith("<!DOCTYPE html") ? (
                                                                    <iframe
                                                                        title={`email-${idx}`}
                                                                        sandbox=""
                                                                        srcDoc={mail.body}
                                                                        className="w-full min-h-[220px] sm:min-h-[360px] lg:min-h-[520px] rounded-lg bg-white"
                                                                    />
                                                                ) : (
                                                                    <div
                                                                        className="prose prose-sm sm:prose max-w-none text-gray-700"
                                                                        dangerouslySetInnerHTML={{ __html: parseHTML(mail.body) }}
                                                                    />
                                                                )}
                                                            </div>

                                                            {/* Separator Line Before Information Button */}
                                                            {/* <div className="h-[1px] bg-gray-300 w-full"></div> */}

                                                            {mail.role === "prospect" && (
                                                                <>
                                                                    {/* Information Buttons */}
                                                                    <div className="bg-white p-3 sm:p-4 flex flex-col gap-3 sm:flex-row">
                                                                        <ToggleButton
                                                                            label={<span>Sentiment <span className="text-lg">✨</span></span>}
                                                                            content={mail.sentiment || "N/A"}
                                                                            type="sentiment"
                                                                            className="px-3 py-1.5 rounded-full text-xs font-medium bg-green-100 text-green-700"
                                                                        />

                                                                        <ToggleButton
                                                                            label={<span>Emotion <span className="text-lg">✨</span></span>}
                                                                            content={mail.emotions?.join("\n") || "N/A"}
                                                                            type="emotion"
                                                                            className="px-3 py-1.5 rounded-full text-xs font-medium bg-green-100 text-green-700"
                                                                        />

                                                                        <ToggleButton
                                                                            label={<span>Key Takeaway <span className="text-lg">✨</span></span>}
                                                                            content={mail.key_takeaways || ""}
                                                                            type="key_takeaway"
                                                                            className="px-3 py-1.5 rounded-full text-xs font-medium bg-green-100 text-green-700"
                                                                        />
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    );
                                                })}

                                            {/* Reply Button Below Last Mail */}
                                            {!replyBox && (
                                                <div className="w-full flex flex-col sm:flex-row gap-3 pt-4">
                                                    <button
                                                        className="w-full sm:w-auto bg-gradient-to-r from-indigo-600 to-violet-600 text-white px-5 py-2.5 rounded-full flex items-center  justify-center gap-2 text-sm font-medium"
                                                        onClick={() => setReplyBox(true)}
                                                    >
                                                        Reply <FaReply />
                                                    </button>
                                                    <button
                                                        className="w-full sm:w-auto border-2 border-violet-500 text-indigo-600 px-5 py-2.5 rounded-full flex items-center justify-center gap-2 text-sm font-medium hover:bg-[#223F9E] hover:text-white transition"
                                                        onClick={() => setReplyBoxSuggest(true)}
                                                    >
                                                        Reply Suggestion <span className="text-lg">✨</span>
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="flex h-full items-center justify-center">
                                            <h2 className="text-md  text-gray-600">No conversation.</h2>
                                        </div>
                                    )}
                                </div>

                                {/* Reply Box at the Bottom */}
                                {replyBox && (
                                    <div className="bg-white p-4 rounded-md shadow border mt-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Subject:</label>
                                            <input
                                                type="text"
                                                value={replyMailSubject}
                                                onChange={(e) => setReplyMailSubject(e.target.value)}
                                                className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-indigo-600 mb-2"
                                            />
                                        </div>
                                        <ReactQuill
                                            theme="snow"
                                            value={replyMailContent}
                                            onChange={(content) => setReplyMailContent(content)}
                                            modules={modules}
                                            className="min-h-[120px] sm:min-h-[180px] mb-6"
                                            placeholder="Write your reply here..."
                                        />
                                        <div className="flex justify-start gap-2 mt-2">
                                            <button
                                                className="bg-gradient-to-r from-indigo-600 to-violet-600 w-30 text-white px-4 py-2 rounded-full hover:bg-blue-700"
                                                onClick={handleMailReply}
                                            >
                                                Reply
                                            </button>
                                            <button
                                                className="bg-gray-200 text-gray-700 px-4 py-2 rounded-full hover:bg-gray-300 transition"
                                                onClick={handleDiscard}
                                            >
                                                Discard
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {replyBoxSuggest && (
                                    <ReplyBox
                                        replyHistory={replyHistory}
                                        handleCloseRepSuggest={() => setReplyBoxSuggest(false)}
                                        activeTab={activeTab}
                                        AutoReply={AutoReply}
                                    />
                                )}
                            </>
                        ) : (
                            <>
                                {/* Information Box */}
                                {/* <div className="shrink-0 px-4 py-3"> */}
                                {selectedLinkedin.length > 0 && (
                                    <div className="sticky top-0 z-30 bg-white px-2 py-2 border-t sm:border-t-0 sm:border-b mt-1  border-gray-100 flex items-center gap-2 sm:gap-4 justify-between">
                                        <div className="flex-1 mx-2 min-w-0">
                                            <h2 className="text-lg font-semibold text-gray-900">
                                                {selectedLinkedin[0] || "Unknown Subject"}
                                            </h2>
                                        </div>
                                        <button
                                            onClick={() => handleLinkedInReplyHistory(selectedLinkedin[1])} // Call the refresh function
                                            className="inline-flex items-center gap-2  rounded-l borde border-gray-20  px-2 py-1.5 sm:px-3 sm:py-2 text-sm font-medium    duration-200 active:scale-[0.97]  transition"
                                        >
                                            <FiRefreshCw className="text-[10px] sm:text-[13px] text-indigo-600 group-hover:text-white text-xl font-extrabold" />
                                        </button>
                                    </div>
                                )}
                                {/* </div> */}


                                {/* Conversation History Linkedin */}
                                <div className="flex-1 overflow-y-auto px-4 py-3 bg-gray-50">
                                    {linkedinMessHistory && linkedinMessHistory.length > 0 ? (
                                        <div className="flex-1 space-y-4">
                                            {linkedinMessHistory
                                                .slice()
                                                .sort((a, b) => new Date(a.receiver_time) - new Date(b.receiver_time))
                                                .map((lnk_mess, idx) => (
                                                    <div key={idx} className="bg-white rounded-xl shadow-sm overflow-hidden">
                                                        {/* Upper Box - Sender Info */}
                                                        <div className="flex items-center justify-between border-b px-4 py-2 bg-white ">
                                                            {/* <div className="flex items-center justify-between px-4 py-2 bg-white"> */}
                                                            <h3 className="text-base sm:text-lg font- text-gray-900">
                                                                {lnk_mess.sender?.attendee_name || "You"}
                                                            </h3>
                                                            <span className="text-xs text-gray-600">
                                                                {lnk_mess.timestamp ? new Date(lnk_mess.timestamp).toLocaleString() : "N/A"}
                                                            </span>
                                                            {/* </div> */}
                                                        </div>

                                                        {/* Separator Line */}
                                                        {/* <div className="h-[1px] bg-gray-300 w-full"></div> */}

                                                        {/* Lower Box - Email Body */}
                                                        <div className="bg-white p-4 shadow-sm">
                                                            {/* If it's a voice note */}
                                                            {lnk_mess.message_marker === "voice_note" && (
                                                                <div className="flex flex-col items-start space-y-2">
                                                                    <h4 className="font-semibold text-gray-800 mb-1">🎧 Voice note </h4>
                                                                    <audio
                                                                        controls
                                                                        src={
                                                                            lnk_mess.voice_url ||
                                                                            `https://autopilotvoicenotes.s3.ap-south-1.amazonaws.com/${lnk_mess.campaign_idx}__${lnk_mess.rep_idx}__${lnk_mess.user_idx}_voice.m4a`
                                                                        }
                                                                        className="w-full max-w-md"
                                                                    >
                                                                        Your browser does not support the audio element.
                                                                    </audio>
                                                                </div>
                                                            )}

                                                            {/* If it's a PDF proposal */}
                                                            {lnk_mess.message_marker === "pdf_proposal" && (
                                                                <div className="flex items-center justify-between bg-red-50 border border-red-200 rounded-lg p-3">
                                                                    <div className="flex items-center gap-2 text-red-700">
                                                                        <FaFilePdf className="text-red-600 text-lg" />
                                                                        <span className="font-medium text-sm">PDF Proposal Attached</span>
                                                                    </div>
                                                                    <a
                                                                        href={
                                                                            lnk_mess.proposal_url ||
                                                                            `https://autopilotproposals.s3.ap-south-1.amazonaws.com/${lnk_mess.campaign_idx}__${lnk_mess.rep_idx}__${lnk_mess.user_idx}.pdf`
                                                                        }
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        className="px-3 py-1 text-xs bg-red-600 text-white rounded-full hover:bg-red-700 transition"
                                                                    >
                                                                        View Proposal
                                                                    </a>
                                                                </div>
                                                            )}

                                                            {/* If it's a normal text message */}
                                                            {(!lnk_mess.message_marker || lnk_mess.message_marker === "text") && (
                                                                <div className="text-gray-700 mt-2 space-y-2">
                                                                    {lnk_mess.message_content
                                                                        ?.split("\n\n")
                                                                        .map((paragraph, index) => (
                                                                            <p key={index} className="text-sm leading-relaxed">
                                                                                {paragraph}
                                                                            </p>
                                                                        ))}
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* Separator Line Before Information Button */}
                                                        {/* <div className="h-[1px] bg-gray-300 w-full"></div> */}

                                                        {lnk_mess.role === "prospect" && (
                                                            <>
                                                                {/* Information Buttons */}
                                                                <div className="bg-white p-4 flex gap-4 items-start text-left">
                                                                    <ToggleButton
                                                                        label={<span>Sentiment <span className="text-lg">✨</span></span>}
                                                                        content={lnk_mess.sentiment || "N/A"}
                                                                        type="sentiment"
                                                                    />

                                                                    <ToggleButton
                                                                        label={<span>Emotion <span className="text-lg">✨</span></span>}
                                                                        content={lnk_mess.emotions?.join("\n") || "N/A"}
                                                                        type="emotion"
                                                                    />

                                                                    <ToggleButton
                                                                        label={<span>Key Takeaway <span className="text-lg">✨</span></span>}
                                                                        content={lnk_mess.key_takeaways || ""}
                                                                        type="key_takeaway"
                                                                    />
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                ))}

                                            {/* Reply Button Below Last LinkedIn */}
                                            {!replyBox && (
                                                <div className="w-full flex flex-col sm:flex-row gap-3 pt-4">
                                                    <button
                                                        className="w-full sm:w-auto bg-gradient-to-r from-indigo-600 to-violet-600 text-white px-5 py-2.5 rounded-full flex items-center  justify-center gap-2 text-sm font-medium"
                                                        onClick={() => setReplyBox(true)}
                                                    >
                                                        Reply <FaReply />
                                                    </button>
                                                    <button
                                                        className="w-full sm:w-auto border-2 border-violet-500 text-indigo-600 px-5 py-2.5 rounded-full flex items-center justify-center gap-2 text-sm font-medium hover:bg-[#223F9E] hover:text-white transition"
                                                        onClick={() => setReplyBoxSuggest(true)}
                                                    >
                                                        Reply Suggestion <span className="text-lg">✨</span>
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="flex h-full items-center justify-center">
                                            <h2 className="text-md font- text-gray-600">No Conversation.</h2>
                                        </div>
                                    )}
                                </div>

                                {/* Reply Box at the Bottom */}
                                {replyBox && (
                                    <div className="bg-white p-4 rounded-xl border border-gray-200 mt-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Message:</label>
                                            <textarea
                                                value={replyLinkedInContent}
                                                onChange={(e) => setReplyLinkedInContent(e.target.value)}
                                                className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-600 mb-2 h-[100px] bg-white text-black overflow-y-auto"
                                                style={{ whiteSpace: "pre-wrap" }}
                                            />
                                        </div>
                                        <div className="flex justify-start gap-2 mt-2">
                                            <button
                                                className="bg-[#223F9E] w-30 text-white px-4 py-2 rounded-full hover:bg-blue-700"
                                                onClick={handleLinkedReply}
                                            >
                                                Reply
                                            </button>
                                            <button
                                                className="bg-gray-300 w-30 text-black px-4 py-2 rounded-full hover:bg-gray-400"
                                                onClick={handleDiscard}
                                            >
                                                Discard
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {replyBoxSuggest && (
                                    <ReplyBox
                                        replyHistory={linkedinMessHistory}
                                        handleCloseRepSuggest={() => setReplyBoxSuggest(false)}
                                        activeTab={activeTab}
                                        AutoReply={AutoReply}
                                    />
                                )}
                            </>
                        )}
                    </div>
                </div >)
            }
        </>

    );
};

const Unibox = () => {

    const [activeTab, setActiveTab] = useState('mail');
    const navigate = useNavigate();

    const handleBack = () => {
        navigate('/email-status');
    };

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col ">
            <HeaderMainPage />



            {/* Page Content Fullscreen */}
            <div className="w-full max-w-7xl mx-auto px-2 sm:px-4 py-2 sm:py-3">
                {/* Main Box Fullscreen */}
                <div className="bg-white rounded-xl border border-gray-200 flex flex-col h-[calc(100vh-120px)]">


                    {/* Object 1 */}
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 px-3 sm:px-4 py-3">

                        {/* Left Section with Back Button */}
                        <div className="flex items-center gap-3 min-w-0">
                            <button onClick={handleBack} className="h-8 w-8 sm:h-9 sm:w-9 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200">
                                <FaArrowLeft className="text-gray-700 text-sm" />
                            </button>

                            <div className="min-w-0">
                                <h1 className="text-sm sm:text-base font-semibold text-gray-900 truncate">{localStorage.getItem("campaign_name")}</h1>
                                <h2 className="text-xs sm:text-sm text-gray-500 truncate">{localStorage.getItem("core_service")}</h2>
                            </div>
                        </div>

                        {/* Tag Navigation with Equal Space and Bold Text */}
                        <div className="flex items-center bg-gray-100 rounded-full p-1 w-full sm:w-auto justify-between sm:justify-start">
                            <button onClick={() => setActiveTab('mail')}
                                className={`flex-1 sm:flex-none justify-center flex items-center gap-2 px-3 sm:px-4 py-1.5 rounded-full text-sm font-medium transition ${activeTab === 'mail' ? 'bg-white text-indigo-600 shadow-sm' : 'text-gray-600 hover:text-gray-900'}`}>
                                Mail
                            </button>
                            <button onClick={() => setActiveTab('linkedin')}
                                className={`flex-1 sm:flex-none justify-center flex items-center gap-2 px-3 sm:px-4 py-1.5 rounded-full text-sm font-medium transition ${activeTab === 'linkedin' ? 'bg-white text-indigo-600 shadow-sm' : 'text-gray-600 hover:text-gray-900'}`}>
                                LinkedIn
                            </button>
                        </div>
                    </div>
                    <div className="border-t border-gray-100" />


                    {/* Object 2 - Using MailboxContent with state */}
                    <div className="flex-1 overflow-hidden flex flex-col">
                        <MailboxContent activeTab={activeTab} />
                    </div>


                </div>
            </div>
        </div>
    );
}

export default Unibox;
